import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SHIPPING_ADDRESSES_URL } from 'src/app/injection-tokens';
import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { KrampShippingAddress } from './kramp-shipping-address';

@Injectable({
  providedIn: 'root',
})
export class KrampShippingAddressService {
  constructor(
    @Inject(SHIPPING_ADDRESSES_URL) readonly serviceURL: string,
    readonly http: HttpClient
  ) {}

  createKrampShippingAddress(krampSpecial: KrampShippingAddress): Observable<KrampShippingAddress> {
    return this.http.post<KrampShippingAddress>(this.serviceURL, krampSpecial);
  }

  getKrampShippingAddresses(): Observable<KrampShippingAddress[]> {
    return this.http.get<KrampShippingAddress[]>(this.serviceURL);
  }

  /** Emits null when the customer has no active Kramp ship-to address */
  getShippingAddressOfCustomer(customerId: string): Observable<KrampShippingAddress | null> {
    return this.http
      .get<KrampShippingAddress>(`${this.serviceURL}/customer/${encodeURIComponent(customerId)}`)
      .pipe(catchError(notFoundAsNull));
  }

  updateKrampShippingAddress(shippingAddress: KrampShippingAddress): Observable<KrampShippingAddress> {
    return this.http.put<KrampShippingAddress>(`${this.serviceURL}/${shippingAddress.id.toString()}`, shippingAddress);
  }

  deleteKrampShippingAddress(shippingAddress: KrampShippingAddress): Observable<HttpResponse<unknown>> {
    return this.http.delete<unknown>(
      `${this.serviceURL}/${shippingAddress.id.toString()}`, //
      { observe: 'response' } //
    );
  }
}

const notFoundAsNull = (error: unknown): Observable<null> =>
  error instanceof HttpErrorResponse && error.status === 404 ? of(null) : throwError(error);
